/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import '../dashboard.css';
import RaisedViolation from './raisedviolation'
import ApprovedViolation from './approvedviolation'
import RejectedViolation from './rejectedviolation'
import AssigendMeForReview from './assignedmeforreview'
import ViolationForPlazaReview from './violationforplazareview'
import PendingViolation from './pendingviolation'
import AssignToOtherViolation from './assigntootherviolation'
import RejectedViolationStatus from './rejectedviolationstatus'
import Loader from 'react-loader-spinner'
import CommonDateRangePicker from '../../../common/daterangepicker'
import { FaSpinner } from "react-icons/fa";
import { getJsonData} from '../../../service/utilService'
import { getAllViolationData, getAllViolationForOthers, getAllViolationUnassignData, getAllViolationUnassignDataBankSide,getLowerFareCountAmt } from '../../../common/apiService'
import { left, right } from '@popperjs/core';
import { UserContext } from "../../../contexts/UserContext";


export default function DashboardWidgets({ setGlobalAssignedToMe, globalassignedtome, setGlobalTotalViolation, globalactiveviolation, setGlobalActiveViolation  }) {
    const [violationData, setViolationData] = useState([]);
    const [totalRaisedLoader, setTotalRaisedLoader] = useState(false);
    const [vioPendingLoader, setVioPendingLoader] = useState(false);
    const [vioReviewLoader, setvioReviewLoader] = useState(false);
    const [vioAssigendLoader, setVioAssigendLoader] = useState(false);
    const [violationDataUnassign, setViolationDataUnassign] = useState({});
    const [violationDataUnassignBankSide, setViolationDataUnassignBankSide] = useState({});
    const [violationForOthers, setViolationForOthers] = useState({ sumAmount: 0, cases: 0 });
    const [totalRaisedCount, setTotalRaisedCount] = useState(0);
    const [totalRaisedAmount, setTotalRaisedAmount] = useState(0);
    const [updatedcount, setupdatedcount] = useState("");
    const [lowerfarecount, setlowerfarecount] = useState(0);
    const [lowerfareamt, setlowerfareamt] = useState(0);
    const [loading, setLoading] = useState(false);
    const userDetail = useContext(UserContext);
 
    useEffect(() => {
         setTotalRaisedCount(totalRaisedCount);
         setTotalRaisedAmount(totalRaisedAmount);
     }, [])

    const [jsonData, setjsonData] = useState(getJsonData(userDetail));
    const COLORS = ['#38C9FF', '#60F3F8', '#303A78', '#389BFF', '#4F38FF', '#dc3545', '#198754', '#0dcaf0', '#6c757d'];
    const [rejviolance, setRejviolance] = useState([])
    const [assingCount, setAssingCount] = useState(0);

    const getData = async () => {
            const plazaIds = Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds; 
            jsonData.plazaIds = plazaIds;

            getAllViolationData(jsonData).then(({data}) =>{
                let totaldata = data;
                if (data && data.length > 0) {
                    setGlobalTotalViolation(totaldata.map(e => e.cases).reduce((a, v) => a + v));
                    setTotalRaisedCount(totaldata.map(e => e.cases).reduce((a, v) => a + v));
                    setTotalRaisedAmount(totaldata.map(e => e.sumAmount).reduce((a, v) => a + v));
                } else {
                    setTotalRaisedCount(0);
                    setTotalRaisedAmount(0);
                    setGlobalTotalViolation(0);
                }
                setViolationData(data);
                setTotalRaisedLoader(false);
            }).catch(err=>{
                setTotalRaisedLoader(false);
            })

            getAllViolationUnassignData(jsonData).then(res =>{
                setViolationDataUnassign(res.data);
                setvioReviewLoader(false);
            }).catch(err=>{
                setvioReviewLoader(false);
            })

            getAllViolationUnassignDataBankSide(jsonData).then(res =>{
                setViolationDataUnassignBankSide(res.data);
                setVioPendingLoader(false);
            }).catch(err=>{
                setVioPendingLoader(false);
            })

            getAllViolationForOthers(jsonData).then(res => {
                setViolationForOthers(res.data);
                setVioAssigendLoader(false);
            }).catch(err=>{
                setVioAssigendLoader(false);
            })
        }

    useEffect(() => {
        // if(assigntomedata.cases || assigntomedata.cases===0){
            setTotalRaisedLoader(true);
            setvioReviewLoader(true);
            setVioPendingLoader(true);
            setVioAssigendLoader(true);
            setViolationData([]);
            getLowerFareCountAmts();
            getData();
        // }
        // eslint-disable-next-line
    }, [jsonData]);


    const getLowerFareCountAmts = async () => {
        setLoading(true);
        const plazaIds = Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds; 
        jsonData.plazaIds = plazaIds;
        const headerJson = {
            ...jsonData
        }
        try {
            let { data } = await getLowerFareCountAmt(headerJson);
            if (data) {
                setlowerfarecount(data.cases)
                if(data.amount!=null)
                {
                    var val = Math.abs(data.amount)
                    if (val >= 10000000) {
                        val = (val / 10000000).toFixed(2) + ' Cr';
                    } else if (val >= 100000) {
                        val = (val / 100000).toFixed(2) + ' Lac';
                    }
                    setlowerfareamt(val)
                }else{
                    var val=0
                    setlowerfareamt(val)
                }
                setLoading(false)
            }
        } catch { 
            console.log('Error is lower fare count');
        }
    }

    const renderCustomizedLabel = ({ x, y, fill, value,name,innerRadius, outerRadius }) => {
        const radius = 25 + innerRadius + (outerRadius - innerRadius);
       
        return (<>
            <text
                x={x}
                y={y}
                dy={0}
                fontSize='11'
                textAnchor={ "middle"}></text>
            <text
                x={x}
                y={y+15}
                dy={0}
                fontSize='14'
                fontWeight="bold"
                textAnchor={ "middle"}></text></>
        );
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active) {
            return (
                <div className="custom-tooltip">
                    <p className="label">{`${payload[0].name} : ${payload[0].value}`}% </p>
                </div>
            );
        }
        return null;
    };

    let loader = totalRaisedLoader || vioPendingLoader || vioReviewLoader || vioAssigendLoader;

    return (

        <><Loader className="loader backloader"
        type="ThreeDots"
        color="#9c1d26"
        height={100}
        width={100}
        visible={loader}
        style={{backgroundColor:'lightgray',position:'fixed'}}
    />

            <div className="row" id="contentheader">
                <div className="col-md-6" id="contenttitle" style={{backgroundColor:'#ffffff',borderRadius:8,padding:5,paddingLeft:10,paddingRight:10}}>
            
                <div className='violation-waiting-count' > Lower Fare Transactions Count :  <span style={{ color: '#303A78',lineHeight: 1 , paddingLeft: 5, fontSize : '27px', fontWeight:'bold' }}>&nbsp; {loading ? <FaSpinner icon="spinner" spin className = "spinner"/> : lowerfarecount} </span> </div>

                    <div className='violation-waiting-count'  style={{flex:1,textAlign:right}}> Lower Fare Amount :  <span style={{ color: '#303A78',lineHeight: 1 , paddingLeft: 10, fontSize : '27px', fontWeight:'bold' }}>&nbsp; {loading ? <FaSpinner icon="spinner" spin className = "spinner"/> : '₹ '+lowerfareamt } </span> </div>
                    
                </div>
                <div className="col-md-4 option">
                    <div className="col-md-2"></div>
                        <CommonDateRangePicker
                        plazaClassName="tollfilter"
                        datepickerClassName="daterange"
                        setjsonData={setjsonData} />
                </div>
            </div>

            <div className="flex-container1">
                <div>
                    <RaisedViolation
                        totalRaisedCount={totalRaisedCount}
                        totalRaisedAmount={totalRaisedAmount}
                        loading={totalRaisedLoader}
                    />
                </div>
                <div style={{ backgroundColor: "#1BB5AD" }}>
                    <ApprovedViolation
                        violationData={violationData}
                        totalCount={totalRaisedCount}
                        loading={totalRaisedLoader} />
                </div>
                <div style={{ backgroundColor: "#F2534B" }}>
                    <RejectedViolation
                        violationData={violationData}
                        totalCount={totalRaisedCount} 
                        loading={totalRaisedLoader}
                        updateddata={updatedcount} />
                </div>
                <div style={{ backgroundColor: "#303A78" }}>
                    <AssigendMeForReview
                        setGlobalAssignedToMe={setGlobalAssignedToMe}
                        assingCount={assingCount}
                        setAssingCount={setAssingCount}
                        globalassignedtome={globalassignedtome}
                        loading={loader}
                        updateddata = {updatedcount}
                        jsonData={jsonData}
                        />
                </div>
            </div>
            <div className="flex-container2">
                <div className="violance-status">
                    <div className="violationstatusgrid">
                        <RejectedViolationStatus
                            jsonData={jsonData}
                            setChartRejviolance={setRejviolance} />
                    </div>
                    <div className="violance-analysis">
                        <p className="rjvnalysis">Rejected Violations Analysis</p>
                        {rejviolance.length>0 ?
                        <ResponsiveContainer width="100%" height="80%">
                            <PieChart >
                                <Pie
                                    data={rejviolance}
                                    dataKey="count"
                                    nameKey="lable"
                                    isAnimationActive={false}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={100}
                                    outerRadius={170}
                                    fill="#8884d8"
                                    label={renderCustomizedLabel}
                                    paddingAngle={2}
                                >
                                    {rejviolance.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                {<Tooltip content={<CustomTooltip />} />}
                            </PieChart>
                        </ResponsiveContainer> : <h1 className="no-record">Record Not Found</h1> }
                    </div>

                </div>
                <div className="rightviolance-block">
                    <div>
                        <AssignToOtherViolation
                            violationData={violationForOthers}
                            totalCount={totalRaisedCount}
                            globalJsonData={jsonData}
                            loading={vioAssigendLoader} />
                    </div>
                    <div>
                        <ViolationForPlazaReview
                            violationDataUnassign={violationDataUnassign}
                            totalCount={totalRaisedCount}
                            setGlobalAssignedToMe={setGlobalAssignedToMe}
                            globalassignedtome={globalassignedtome} 
                            globalactiveviolation={globalactiveviolation}
                            setGlobalActiveViolation={setGlobalActiveViolation}
                            jsonData={jsonData}
                            loading={vioReviewLoader}/>
                    </div>
                    <div>
                        <PendingViolation
                            violationData={violationDataUnassignBankSide}
                            totalCount={totalRaisedCount}
                            loading={vioPendingLoader} />
                    </div>
                </div>
            </div>
        </>
    )
}
